module.exports = __webpack_public_path__ + "static/media/WS1@2x.c00b9945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WS/WS1@2x.png
// module id = 747
// module chunks = 0